/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
export default {
  data: function data() {
    return {
      userName: '王强',
      company: '威尔数据',
      jujue: require('@/assets/shenpi/jujue.png'),
      //拒绝
      quxiao: require('@/assets/shenpi/quxiao.png'),
      //取消
      bg: require('@/assets/shenpi/yellow-bg.png'),
      //审批中
      tongguo: require('@/assets/shenpi/tongguo.png'),
      //通过
      id: '2',
      //0：未审批，1：审批同意 2：审批拒绝 3已撤销
      userInfo: {
        userLname: '',
        //姓名
        company: '',
        //公司
        applyLx: '',
        //预约类型
        bh: '',
        //会议编号
        lname: '',
        //会议名称
        roomName: '',
        //会议地点
        kssj: '',
        //开始时间
        jssj: '',
        //结束时间
        ksqdsj: '',
        //入场准备时间
        jsqdsj: '',
        //清场准备事假
        summary: '' //会议概要 备注

      },
      time: '',
      //发起请求时间
      list: [],
      //审批人列表
      approver: {},
      active: '1',
      //进度条位置
      isCancel: false,
      //用于判断开会时间与当前时间的比较
      show: false,
      closeInfo: {},
      //关闭的信息
      QRTime: true,
      //会议二维码时间
      cancelId: '',
      //判断是撤销申请还是取消会议
      bh: ''
    };
  },
  methods: {
    // 返回
    back: function back() {
      if (this.$utils.Tools.getUrlParams('state') && !this.$route.query.bh) {
        this.$utils.WeiXin.closeWindow();
      } else {
        this.$router.go(-1);
      }
    },
    getData: function getData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  bh: _this.bh,
                  userSerial: _this.$utils.Store.getItem('userSerial')
                };
                _context.next = 3;
                return _this.$api.Meeting.selectByPrimaryDetail(params).then(function (res) {
                  var code = res.code,
                      data = res.data,
                      msg = res.msg;

                  if (+code !== _this.$code.success) {
                    _this.$utils.Tools.loadHide();

                    _this.$utils.Tools.toastShow(msg);
                  } else {
                    _this.list = data.list;
                    _this.id = data.approveState; //通过会议状态获取审批者

                    /**
                     * 1:会议状态为1-》申请中
                     * 2：会议状态为2==》通过
                     * 3：会议状态为3=》拒绝
                     *
                     */

                    //通过会议状态获取审批者

                    /**
                     * 1:会议状态为1-》申请中
                     * 2：会议状态为2==》通过
                     * 3：会议状态为3=》拒绝
                     *
                     */
                    if (_this.id == 0 || _this.id == 1 || _this.id == 5 || _this.id == 6) {
                      var userarr = [];
                      _this.approver = _this.list[0];

                      _this.list.forEach(function (item) {
                        userarr.push(item.userLname);
                      });

                      _this.approver.userLname = userarr.join('/');
                    } else {
                      _this.list = _this.list.filter(function (item) {
                        return item.spFlagDz == 1;
                      });
                      _this.approver = _this.list[0];
                    }

                    _this.time = data.sj.substring(0, 16);
                    _this.userInfo = {
                      userLname: data.userLname,
                      //姓名 orgName
                      company: _this.$utils.Store.getItem('orgName'),
                      applyLx: data.applyLx,
                      //预约类型
                      bh: data.bh,
                      //会议编号
                      lname: data.lname,
                      //会议名称
                      roomName: data.roomName,
                      //会议地点
                      kssj: data.kssj,
                      //开始时间
                      jssj: data.jssj,
                      //结束时间
                      ksqdsj: data.ksqdsj,
                      //入场准备时间
                      jsqdsj: data.jsqdsj,
                      //清场准备事假
                      summary: data.summary //会议概要 备注

                    };
                    var nowTime = new Date().getTime();
                    var start_time = moment(_this.userInfo.kssj).toDate().getTime();
                    var end_time = moment(_this.userInfo.jssj).toDate().getTime(); //会议开始时间

                    //会议开始时间
                    if (nowTime < start_time) {
                      _this.isCancel = true;
                    }

                    if (nowTime > end_time) _this.QRTime = false;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //取消会议
    showCancel: function showCancel(item) {
      this.cancelId = item;
      this.show = true;
    },
    cancelMeeting: function cancelMeeting() {
      this.show = false;
    },
    //确定取消会议 meetDelete
    sureMeeting: function sureMeeting() {
      var _this2 = this;

      this.show = false;
      var params = {
        bh: this.bh,
        userSerial: this.$utils.Store.getItem('userSerial'),
        flag: this.cancelId
      };
      this.$api.Meeting.meetDelete(params).then(function (res) {
        if (res.code == 600) {
          var msg = '';

          if (_this2.cancelId == 4) {
            setTimeout(function () {
              _this2.$router.go(-1);
            }, 2000);
            msg = '会议申请已撤销';
          } else if (_this2.cancelId == 5) {
            msg = '会议申请已取消';

            _this2.getData();

            _this2.id = 5;
          }

          _this2.$utils.Tools.toastShow(msg);

          setTimeout(function () {
            window.location.reload();
          }, 2000);
        } else {
          _this2.$utils.Tools.toastShow(res.msg);
        }
      });
    }
  },
  created: function created() {
    var state = this.$utils.Tools.getUrlParams('state');
    this.bh = this.$route.query.bh || state; // if(this.id=='0'){
    //     this.active = '0'
    // }else
    //  this.active = '1'
  },
  mounted: function mounted() {
    this.getData();
  }
};